/**
 * @file 首页内容
 */

import React from 'react'

import Layout from 'components/Layout'
import { headerThemeContext } from 'components/Header/Pc'
import UsageGuide from 'components/pages/index/UsageGuide'
import { Navigatable } from 'components/Navigator'

import Banner from 'components/pages/index/Banner'
import Intro1 from 'components/pages/index/Intro1'
import Advantage from 'components/pages/index/Advantage'
import Maintenance from 'components/Maintenance'

export function PageContent() {
  return (
    <Navigatable>
      <Banner />
      <Intro1 />
      <Advantage />
      <UsageGuide />
    </Navigatable>
  )
}

export default function IndexPage() {
  return (
    <headerThemeContext.Provider value="default" >
      <Layout
        title=""
        keywords="NiuLink, 共享计算平台"
        description="NiuLink 简单高效的共享计算平台"
        trackPv
      >
        <Maintenance />
      </Layout>
    </headerThemeContext.Provider>
  )
}
